import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { GoogleSheetsPattern } from '@rp/shared/models';

import { Validation } from './enums/validation.enum';

export const googleSheetsUrlValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }
    if (typeof value === 'string' && !GoogleSheetsPattern.test(value)) {
      return { [Validation.GoogleSheets]: true };
    }

    return null;
  };
};
